import Axios from "axios";
import { Routes } from "../constant/api_url";

export const axios = Axios.create({
  baseURL: Routes.API_HOSTNAME,
  timeout: 1000000000,
  responseType: "json"
});

axios.interceptors.request.use(
  async (config) => {
    config.headers.authorization = `Bearer ${JSON.parse(
      localStorage.getItem("token")
    )}`;
    config.headers.call_type = 'PANEL';
    config.headers.is_prime = 1;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    }
    return Promise.reject(error);
  }
);

export default axios;
